// extracted by mini-css-extract-plugin
export var dropdown = "_ov-1";
export var hidden = "_ov-0";